import Cart from './cart';
import '../components/tc-modal';
import '../components/tc-button';
import i18n from 'roddeh-i18n';
export default class QueryDiscountCodeListener {
    static init() {
        if (!this.initialized) {
            this.initialized = true;
        }
        // Po załadowaniu skryptu sprawdź, czy istnieje parametr GET "?addpcode={kod}"
        // jeżeli tak - dodaj go do koszyka poprzez API
        const urlParams = new URLSearchParams(window.location.search);
        const discountCode = urlParams.get(this.queryParam);
        if (discountCode !== null && discountCode.length > 0) {
            this.addDiscountCode(discountCode);
        }
    }
    static addDiscountCode(discountCode) {
        Cart.addDiscountCode(discountCode)
            .then((info) => {
            const discountCodeName = info.personal_discount_code ?? info.discount_code;
            const html = `<tc-modal visible>
                    <p>${i18n('Discount code added to cart')}<br>${discountCodeName}</p>
                    <tc-button type="primary" width="full" modal-close>OK</tc-button>
                </tc-modal>`;
            const modal = document.createElement('div');
            modal.innerHTML = html;
            document.body.append(modal);
        })
            .catch((err) => {
            console.error(`Failed to add discount code ${discountCode}`, err);
        });
    }
}
QueryDiscountCodeListener.initialized = false;
QueryDiscountCodeListener.queryParam = 'addpcode';
